import { createApiThunk } from "./thunkWrapper";

export const schedule = createApiThunk("quiz/schedule", (payload) => ({
  method: "POST",
  endPoint: "scheduleQuiz", 
  data: payload,
}));

export const getScheduleQuiz = createApiThunk("quiz/getschedule", (payload) => ({
  method: "GET",
  endPoint: "getScheduleQuiz", 
  data: payload,
}));

export const deleteScheduleQuiz = createApiThunk("quiz/deleteschedule", (payload) => ({
  method: "POST",
  endPoint: "deleteScheduleQuiz", 
  params: payload,
}));
